import React from 'react';
import './team section.css';
import linkedinIcon from '../../assets/linkedin-icon.svg';
import twitterIcon from '../../assets/twittericon.svg';
import youtubeIcon from '../../assets/youtube-icon.svg';

const TeamMemberModal = ({ member, isOpen, onClose }) => {
  if (!isOpen || !member) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        
        <div className="modal-header">
          <div className="modal-avatar">
            <img 
              src={member.image} 
              alt={member.name + ' headshot'} 
              style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} 
            />
          </div>
          <div className="modal-info">
            <h2 className="modal-name">{member.name}</h2>
            <p className="modal-position">{member.position}</p>
          </div>
        </div>
        
        <div className="modal-body">
          <div className="modal-bio">
            {member.bio.split('\n\n').map((paragraph, index) => (
              <p key={index} className="modal-bio-paragraph">
                {paragraph}
              </p>
            ))}
          </div>
          
          <div className="modal-social-links">
            <h4>Connect with {member.firstName}</h4>
            <div className="social-links">
              {!member.hiddenSocial?.includes('linkedin') && (
                <a
                  className="social-link linkedin"
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <img src={linkedinIcon} alt="LinkedIn" className="social-link-icon" />
                </a>
              )}
              {!member.hiddenSocial?.includes('twitter') && (
                <a
                  className="social-link twitter"
                  href={member.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <img src={twitterIcon} alt="Twitter" className="social-link-icon" />
                </a>
              )}
              {!member.hiddenSocial?.includes('youtube') && (
                <a
                  className="social-link youtube"
                  href={member.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <img src={youtubeIcon} alt="YouTube" className="social-link-icon" />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMemberModal;
